// assets/quantity-discount.js
function getQty(ctx) {
  var r = document.querySelector('product-detail-quantities input[data-product-detail-quantities-el="option-choice"]:checked');
  if (r) {
    var v = Number(r.dataset.units || r.value);
    if (!isNaN(v) && v > 0) return v;
  }
  var qs = ctx && ctx.querySelector('quantity-selector input[name="quantity"]');
  if (qs) {
    var q = Number(qs.value);
    if (!isNaN(q) && q > 0) return q;
  }
  var qf = ctx && ctx.querySelector('input[name="quantity"]');
  if (qf) {
    var q2 = Number(qf.value);
    if (!isNaN(q2) && q2 > 0) return q2;
  }
  return 1;
}